/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SaveLinkItemDto } from './SaveLinkItemDto';
import {
    SaveLinkItemDtoFromJSON,
    SaveLinkItemDtoFromJSONTyped,
    SaveLinkItemDtoToJSON,
} from './SaveLinkItemDto';

/**
 * 
 * @export
 * @interface SaveLinksDto
 */
export interface SaveLinksDto {
    /**
     * 
     * @type {Array<SaveLinkItemDto>}
     * @memberof SaveLinksDto
     */
    links: Array<SaveLinkItemDto>;
}

/**
 * Check if a given object implements the SaveLinksDto interface.
 */
export function instanceOfSaveLinksDto(value: object): value is SaveLinksDto {
    if (!('links' in value) || value['links'] === undefined) return false;
    return true;
}

export function SaveLinksDtoFromJSON(json: any): SaveLinksDto {
    return SaveLinksDtoFromJSONTyped(json, false);
}

export function SaveLinksDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveLinksDto {
    if (json == null) {
        return json;
    }
    return {
        
        'links': ((json['links'] as Array<any>).map(SaveLinkItemDtoFromJSON)),
    };
}

export function SaveLinksDtoToJSON(value?: SaveLinksDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'links': ((value['links'] as Array<any>).map(SaveLinkItemDtoToJSON)),
    };
}

